import { render, staticRenderFns } from "./AddRentTariff.vue?vue&type=template&id=8b8ef400&scoped=true&lang=pug&"
import script from "./AddRentTariff.vue?vue&type=script&lang=js&"
export * from "./AddRentTariff.vue?vue&type=script&lang=js&"
import style0 from "./AddRentTariff.vue?vue&type=style&index=0&id=8b8ef400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8ef400",
  null
  
)

export default component.exports